import Dashboard from "../assets/images/sidebarIcons/Dashboard.svg";
import Home from "../assets/images/sidebarIcons/Home.svg";
import Sales from "../assets/images/sidebarIcons/Sales.svg";
import Marketing from "../assets/images/sidebarIcons/Marketing.svg";
import Finance from "../assets/images/sidebarIcons/Finance.svg";
import Inventory from "../assets/images/sidebarIcons/Inventory.svg";
import Logistics from "../assets/images/sidebarIcons/Logistics.svg";
import Services from "../assets/images/sidebarIcons/Services.svg";
import HR from "../assets/images/sidebarIcons/HR.svg";
import IT from "../assets/images/sidebarIcons/IT.svg";
import Legal from "../assets/images/sidebarIcons/Legal.svg";
import Security from "../assets/images/sidebarIcons/Security.svg";
import Reports from "../assets/images/sidebarIcons/Reports.svg";
// import Automation from "../assets/images/sidebarIcons/Home.svg";

import { ALL_PERMISSION_KEYS } from "./permissionModules";

export const sidebarConfig = [
  {
    key: "dashboard",
    label: "Dashboard",
    icon: Dashboard,
    submodules: [
      { label: "Executive Overview", path: "dashboard/overview", permissionKey: "dashboard:overview" },
      { label: "Sales Dashboard", path: "dashboard/sales", permissionKey: "dashboard:sales" },
      { label: "HR Dashboard", path: "dashboard/hr", permissionKey: "dashboard:hr" },
      { label: "Finance Dashboard", path: "dashboard/finance", permissionKey: "dashboard:finance" },
      { label: "IT Dashboard", path: "dashboard/it", permissionKey: "dashboard:it" },
    ],
  },
  {
    key: "home",
    label: "Home",
    icon: Home,
    path: "home",
    settings: [
      { label: "My Organization", path: "home/settings/my-organization" },
      { label: "Divisions", path: "home/settings/divisions" },
      { label: "Branches", path: "home/settings/branches" },
      { label: "Departments", path: "home/settings/departments" },
      { label: "Designations", path: "home/settings/designations" },
      { label: "Notifications", path: "home/settings/notifications" },
      { label: "Dashboard Widgets", path: "home/settings/widgets" },
    ],
  },
  {
    key: "sales",
    label: "Sales",
    icon: Sales,
    submodules: [
      { label: "Sales Dashboard", path: "sales/dashboard", permissionKey: "sales:dashboard" },
      { label: "Open Leads", path: "sales/open-leads", permissionKey: "sales:leads" },
      { label: "Expo Leads", path: "sales/expo-leads", permissionKey: "sales:expo-leads" },
      { label: "Clients", path: "sales/clients", permissionKey: "sales:clients" },
      { label: "Leads", path: "sales/leads", permissionKey: "sales:leads" },
      { label: "Onboarded Clients", path: "sales/sales-orders", permissionKey: "sales:orders" },
      {
        label: "Opportunities",
        permissionKey: "sales:opportunities",
        children: [
          { label: "Pipeline View", path: "sales/opportunities/pipeline-view" },
          { label: "Opportunities", path: "sales/opportunities/view-all" },
        ],
      },
      { label: "Quotations", path: "sales/quotations", permissionKey: "sales:quotations" },
      { label: "Sales Channels", path: "sales/sales-channels", permissionKey: "sales:channels" },
      { label: "Delivery Management", path: "sales/delivery-management", permissionKey: "sales:delivery" },
      { label: "Invoices", path: "sales/invoices", permissionKey: "sales:invoices" },
      { label: "Payments", path: "sales/payments", permissionKey: "sales:payments" },
      { label: "Sales Returns", path: "sales/sales-returns", permissionKey: "sales:returns" },
    ],
    settings: [
      { label: "Sales Pipeline Stages", path: "sales/settings/pipeline-stages" },
      { label: "Quotation Templates", path: "sales/settings/quotation-templates" },
      { label: "Tax & Pricing Rules", path: "sales/settings/tax-pricing" },
      { label: "Expo Management", path: "sales/settings/expo-management" },
      { label: "Business Verticals", path: "sales/settings/business-verticals" },
      { label: "Business Categories", path: "sales/settings/business-categories" },
      { label: "Programs", path: "sales/settings/programs" },
    ],
  },
  {
    key: "marketing",
    label: "Marketing",
    icon: Marketing,
    submodules: [
      { label: "Marketing Dashboard", path: "marketing/dashboard", permissionKey: "marketing:dashboard" },
      { label: "Campaigns", path: "marketing/campaigns", permissionKey: "marketing:campaigns" },
      { label: "Promotions", path: "marketing/promotions", permissionKey: "marketing:promotions" },
      { label: "Audience", path: "marketing/audience", permissionKey: "marketing:audience" },
    ],
    settings: [
      { label: "Email Templates", path: "marketing/settings/email-templates" },
    ],
  },
  {
    key: "finance",
    label: "Finance",
    icon: Finance,
    submodules: [
      { label: "Finance Dashboard", path: "finance/dashboard", permissionKey: "finance:dashboard" },
      { label: "Accounts", path: "finance/accounts", permissionKey: "finance:accounts" },
      { label: "Payments", path: "finance/payments", permissionKey: "finance:payments" },
      { label: "Expenses", path: "finance/expenses", permissionKey: "finance:expenses" },
      { label: "Taxation", path: "finance/taxation", permissionKey: "finance:taxation" },
    ],
    settings: [
      { label: "Chart of Accounts", path: "finance/settings/chart-of-accounts" },
      { label: "Currency & Tax", path: "finance/settings/currency-tax" },
    ],
  },
  {
    key: "inventory",
    label: "Inventory",
    icon: Inventory,
    submodules: [
      { label: "Inventory Dashboard", path: "inventory/dashboard", permissionKey: "inventory:dashboard" },
      { label: "Stock Overview", path: "inventory/stock", permissionKey: "inventory:stock" },
      { label: "Purchase Orders", path: "inventory/purchase-orders", permissionKey: "inventory:purchase-orders" },
      { label: "Suppliers", path: "inventory/suppliers", permissionKey: "inventory:suppliers" },
    ],
    settings: [
      { label: "Warehouses", path: "inventory/settings/warehouses" },
      { label: "Stock Alerts", path: "inventory/settings/stock-alerts" },
    ],
  },
  {
    key: "logistics",
    label: "Logistics",
    icon: Logistics,
    submodules: [
      { label: "Logistics Dashboard", path: "logistics/dashboard", permissionKey: "logistics:dashboard" },
      { label: "Shipments", path: "logistics/shipments", permissionKey: "logistics:shipments" },
      { label: "Delivery Tracking", path: "logistics/delivery-tracking", permissionKey: "logistics:tracking" },
      { label: "Vendors", path: "logistics/vendors", permissionKey: "logistics:vendors" },
    ],
    settings: [
      { label: "Shipping Zones", path: "logistics/settings/shipping-zones" },
      { label: "Carrier Setup", path: "logistics/settings/carrier-setup" },
    ],
  },
  {
    key: "services",
    label: "Services",
    icon: Services,
    submodules: [
      { label: "Services Dashboard", path: "services/dashboard", permissionKey: "services:dashboard" },
      { label: "Service Requests", path: "services/requests", permissionKey: "services:requests" },
      { label: "Service Catalogue", path: "services/catalogue", permissionKey: "services:catalogue" },
    ],
    settings: [
      { label: "Service Categories", path: "services/settings/categories" },
      { label: "SLA Rules", path: "services/settings/sla-rules" },
    ],
  },
  {
    key: "hr",
    label: "HR",
    icon: HR,
    submodules: [
      { label: "HR Dashboard", path: "hr/dashboard", permissionKey: "hr:dashboard" },
      { label: "Recruitment Management", path: "hr/recruitment-management", permissionKey: "hr:recruitment" },
      { label: "Employee Management", path: "hr/employee-management", permissionKey: "hr:employees" },
      {
        label: "Organization Structure",
        permissionKey: "hr:organization",
        children: [
          { label: "Divisions", path: "hr/divisions", permissionKey: "hr:divisions" },
          { label: "Departments", path: "hr/departments", permissionKey: "hr:departments" },
        ],
      },
      { label: "Attendance Management", path: "hr/attendance-management", permissionKey: "hr:attendance" },
      { label: "Leave Management", path: "hr/leave-management", permissionKey: "hr:leave" },
      { label: "Payroll Management", path: "hr/payroll-management", permissionKey: "hr:payroll" },
      { label: "Expense Management", path: "hr/expense-management", permissionKey: "hr:expenses" },
      { label: "Document Management", path: "hr/document-management", permissionKey: "hr:documents" },
      { label: "Performance Management", path: "hr/performance-management", permissionKey: "hr:performance" },
      // { label: "LMS Management", path: "hr/lms-management", permissionKey: "hr:lms" },
      {
        label: "LMS Management",
        permissionKey: "hr:lms",
        children: [
          { label: "Dashboard", path: "hr/lms-management/dashboard", permissionKey: "hr:lms-dashboard" },
          { label: "Courses List", path: "hr/lms-management/courses", permissionKey: "hr:lms-courses" },
          { label: "Assign Courses", path: "hr/lms-management/assign-courses", permissionKey: "hr:lms-assign-courses" },
        ],
      },
      { label: "HR Letter & Policy", path: "hr/letter-policy", permissionKey: "hr:letter-policy" },
      { label: "HR Case Tracker", path: "hr/case-tracker", permissionKey: "hr:case-tracker" },
      { label: "Exit Management", path: "hr/exit-management", permissionKey: "hr:exit" },
    ],
    settings: [
      { label: "Shifts", path: "hr/settings/shifts" },
      { label: "Holidays", path: "hr/settings/holidays" },
      { label: "LeaveTypes", path: "hr/settings/leave-types" },
      { label: "Leave Policies", path: "hr/settings/leave-policies" },
      { label: "Review Workflows", path: "hr/settings/kra/review/workflows" },
      { label: "Case Category", path: "hr/settings/case-category" },
      { label: "Payroll Setup", path: "hr/settings/payroll-setup" },
    ],
  },
  {
    key: "it",
    label: "IT",
    icon: IT,
    submodules: [
      { label: "IT Dashboard", path: "it/dashboard", permissionKey: "it:dashboard" },
      { label: "Assets", path: "it/assets", permissionKey: "it:assets" },
      { label: "Tickets", path: "it/tickets", permissionKey: "it:tickets" },
      { label: "Access Management", path: "it/access-management", permissionKey: "it:access" },
    ],
    settings: [
      { label: "Asset Categories", path: "it/settings/asset-categories" },
      { label: "Ticket Priorities", path: "it/settings/ticket-priorities" },
    ],
  },
  {
    key: "legal",
    label: "Legal",
    icon: Legal,
    submodules: [
      { label: "Legal Dashboard", path: "legal/dashboard", permissionKey: "legal:dashboard" },
      { label: "Contracts", path: "legal/contracts", permissionKey: "legal:contracts" },
      { label: "Compliance", path: "legal/compliance", permissionKey: "legal:compliance" },
    ],
    settings: [
      { label: "Contract Templates", path: "legal/settings/contract-templates" },
    ],
  },
  {
    key: "security",
    label: "Security",
    icon: Security,
    submodules: [
      { label: "Security Dashboard", path: "security/dashboard", permissionKey: "security:dashboard" },
      { label: "Users", path: "security/users", permissionKey: "security:users" },
      { label: "Invitations", path: "security/invitations", permissionKey: "security:invitations" },
      { label: "Roles & Permissions", path: "security/roles-and-permissions", permissionKey: "security:roles" },
      { label: "Audit Logs", path: "security/audit-logs", permissionKey: "security:audit" },
    ],
    settings: [
      { label: "Password Policy", path: "security/settings/password-policy" },
      { label: "Two-Factor Auth", path: "security/settings/2fa" },
    ],
  },
  {
    key: "reports",
    label: "Reports",
    icon: Reports,
    submodules: [
      { label: "Dashboard", path: "reports/dashboard", permissionKey: "reports:dashboard" },
      { label: "Duplicate Clients", path: "reports/duplicate-clients", permissionKey: "reports:sales" },
      { label: "Sales Reports", path: "reports/sales", permissionKey: "reports:sales" },
      { label: "Financial Reports", path: "reports/financial", permissionKey: "reports:financial" },
      { label: "HR Reports", path: "reports/hr", permissionKey: "reports:hr" },
      { label: "Daily Followup", path: "reports/daily-followup", permissionKey: "reports:daily-followup" },
      { label: "Client Stage", path: "reports/client-stage", permissionKey: "reports:client-stage" },
      { label: "Onboarding Calendar", path: "reports/onboarding-calendar", permissionKey: "reports:onboarding" },
      { label: "MIS Report", path: "reports/mis-report", permissionKey: "reports:mis" },
    ],
    settings: [
      { label: "Scheduled Reports", path: "reports/settings/scheduled" },
    ],
  },
  {
  key: "automation",
  label: "Automation",
  icon: Reports,
  submodules: [
    {
      key: "automation:push-notifications",
      label: "Push Notifications",
      path: "automation/push-notifications",
    },
    {
      key: "automation:notification-history",
      label: "Notification History",
      path: "automation/notification-history",
    },{
      key:"automation:email-workflows",
      label:"Email Workflows",
      path:"automation/email-workflows",
    },
     {
      key: "automation:whatsapp-workflows",
      label: "WhatsApp Workflows",
      path: "automation/whatsapp-workflows",
    },
    {
      key: "automation:whatsapp-workflow-history",
      label: "WhatsApp Workflow History",
      path: "automation/whatsapp-workflow-history",
    }
  ],
},
];

export const settingsConfig = sidebarConfig.reduce((acc, m) => {
  acc[m.key] = {
    key: m.key,
    label: m.label,
    settings: (m.submodules || []).map((s) => ({ label: `${s.label} Settings`, path: `${m.key}/settings` })),
  };
  return acc;
}, {});

// ─── Permission processing operations ───

export const getVisibleKeysForUser = (user) => {
  const visibleKeysSet = new Set();
  if (!user) return visibleKeysSet;

  const isOwner = user?.role === "owner" || user?.isOwner === true;
  
  if (isOwner) {
    ALL_PERMISSION_KEYS.forEach((key) => visibleKeysSet.add(key));
    return visibleKeysSet;
  }

  const rolePermissions = user?.roleId?.permissions || {};
  const userPermissions = user?.permissions || {};
  const mergedPermissions = { ...rolePermissions, ...userPermissions };

  Object.keys(mergedPermissions).forEach((key) => {
    if (mergedPermissions[key]?.view === true && mergedPermissions[key]?.hide !== true) {
      visibleKeysSet.add(key);
    }
  });

  return visibleKeysSet;
};

// ──── 2. An enhanced function that filters each individual settings page ────
// Replace only the filterSidebarByPermissions function with this:

export const filterSidebarByPermissions = (visibleKeysSet) => {
  return sidebarConfig
    .map((mod) => {
      const filteredSubmodules = (mod.submodules || []).filter((s) => {
        const subKey = s.permissionKey || `${mod.key}:${s.path.split('/').slice(1).join('/') || s.path}`;
        return visibleKeysSet.has(subKey) || visibleKeysSet.has(mod.key);
      });

      const filteredSettings = (mod.settings || []).filter((s) => {
        const settingSlug = s.path.split('/').pop();
        const settingPermissionKey = `${mod.key}:settings:${settingSlug}`;
        return visibleKeysSet.has(settingPermissionKey);
      });

      return { 
        ...mod, 
        submodules: filteredSubmodules, 
        settings: filteredSettings 
      };
    })
    .filter((mod) => {
      const hasModuleAccess = visibleKeysSet.has(mod.key);

      if (mod.path && (!mod.submodules || mod.submodules.length === 0)) {
        return hasModuleAccess;
      }

      return hasModuleAccess || 
             (mod.submodules && mod.submodules.length > 0) || 
             (mod.settings && mod.settings.length > 0);
    });
};